import { onMounted } from '@vue/composition-api'
import { breakComma, formatDateKanji, dateDiff } from '@/util/common'
import { ESTIMATE_PRINT_DATA_NAME } from '@/util/constants'
import * as _ from 'lodash'

export const ServiceLicensePurchaseConfirm = (props, context) => {
  const store = context.root.$store
  const { purchase: { paymentList } } = store.state

  // トークン（別ウィンドウで表示する印刷画面のトークン認証で使用）
  const token = store.state.auth.token

  const basicProduct = (pack) => _.filter(pack.product_lists, product => product.classification === 2)
  const optionProduct = (pack) => _.filter(pack.product_lists, product => product.classification === 3)

  onMounted(() => {

    // 印刷機能に渡すためのデータ(JSON)を生成し、ローカルストレージに保存
    // 保持するデータが多くならないよう必要なデータのみに絞る
    localStorage.removeItem(ESTIMATE_PRINT_DATA_NAME)
    const printData = {}
    printData.print_type = 'service-purchase'
    printData.name = store.state.contract.name
    printData.total_fee = paymentList.total_fee
    const packageListWork = []
    for (let i = 0; i < paymentList.package_lists.length; i++) {
      const _pack = paymentList.package_lists[i]

      const basicProductData = basicProduct(_pack)
      const basicProductWork = []
      for (let k = 0; k < basicProductData.length; k++) {
        const product = basicProductData[k]
        basicProductWork.push({
          name: product.name,
          license_number: product.license_number,
          period_start: product.period_start,
          period_end: product.period_end,
          basic_price: product.basic_price,
          add_price: product.add_price
        })
      }

      const optionProductData = optionProduct(_pack)
      const optionProductWork = []
      for (let k = 0; k < optionProductData.length; k++) {
        const product = optionProductData[k]
        optionProductWork.push({
          name: product.name,
          license_number: product.license_number,
          period_start: product.period_start,
          period_end: product.period_end,
          basic_price: product.basic_price,
          add_price: product.add_price
        })
      }

      packageListWork.push({
        package_name: _pack.package_name,
        sub_total_fee: _pack.sub_total_fee,
        period_end: _pack.period_end,
        basic_products: basicProductWork,
        option_products: optionProductWork
      })
    }
    printData.package_lists = packageListWork
    const printJSON = JSON.stringify(printData)
    localStorage.setItem(ESTIMATE_PRINT_DATA_NAME, printJSON)

  })

  const close = () => {
    context.emit('closeViewConfirm')
  }
  const openViewComplete = () => {
    context.emit('openViewComplete')
  }

  return {
    token,
    breakComma,
    formatDateKanji,
    paymentList,
    close,
    openViewComplete
  }
}
